<template>
    <div class="info-banner" v-if="userBanner?.length">
        <div class="info-banner__title">
            Важная информация
        </div>
        <div class="info-banner__list">
            <div class="info-banner__item" v-for="banner in userBanner" :key="banner.id">
                <div v-if="banner.icon" class="info-banner__icon">
                    <img :src="banner.icon" alt="info">
                </div>
                <div class="info-banner__content">
                    <div class="info-banner__name">{{ banner.title }}</div>
                    <div v-if="banner.text" class="info-banner__text" v-html="banner.text"></div>
                </div>
            </div>
          
        </div>
    </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
	name: "InfoBanner",
    mounted() {
        this.requestUserInfoBanner();
    },

    methods: {
        ...mapActions({
			requestUserInfoBanner: 'user/requestUserInfoBanner',
		})
    },
    computed: {
        ...mapGetters({
            userBanner: 'user/getUserBanner',
        })
    }
}
</script>

